document.addEventListener("DOMContentLoaded", function () {
  const body = document.body;

  if (
    body.classList.contains("template--product-mens") ||
    body.classList.contains("template--product-womens")
  ) {
    // Create popup HTML structure
    const popupHTML = `
      <div id="movv-popup-overlay" style="display: none; position: fixed; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0,0,0,0.5); z-index: 9998; display: flex; justify-content: center; align-items: center;">
        <div id="movv-popup" style="background-color: white; width: 95%; max-width: 480px; border-radius: 24px; padding: 32px 32px 18px; text-align: center; position: relative; box-shadow: 0 20px 40px rgba(0,0,0,0.12); font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;">
          
          <button id="movv-popup-close" style="position: absolute; top: 20px; right: 20px; background: none; border: none; font-size: 26px; cursor: pointer; color: #333;">&times;</button>
          
          <div style="margin: 0 auto 32px; max-width: 300px;">
            <img src="https://cdn.shopify.com/s/files/1/0840/0165/3068/files/movv-t-shirt-transparent.webp?v=1742431427" alt="MOVV T-shirt" style="width: 100%; height: auto;">
          </div>
          
          <h2 style="font-size: 26px; font-weight: 700; margin-bottom: 20px; color: #111;">Limited Time Offer</h2>
          
          <p style="font-size: 16px; line-height: 1.6; color: #333; margin-bottom: 28px;">
            Keep moving forward.<br />
            Get a free t-shirt with your pair of MOVV running shoes.
          </p>
          
          <button id="movv-popup-confirm" style="
            background-color: white;
            color: black;
            border: 2px solid black;
            border-radius: 12px;
            padding: 16px 24px;
            width: 100%;
            font-weight: 600;
            font-size: 15px;
            cursor: pointer;
            transition: all 0.2s ease;
          ">SHOP YOUR PAIR OF MOVV's</button>
          
        </div>
      </div>
    `;

    document.body.insertAdjacentHTML('beforeend', popupHTML);

    const popupOverlay = document.getElementById('movv-popup-overlay');
    const popupClose = document.getElementById('movv-popup-close');
    const popupConfirm = document.getElementById('movv-popup-confirm');

    popupOverlay.style.display = 'none';

    // ✨ Close when clicking X
    popupClose.addEventListener('click', hidePopup);

    // ✨ Close when clicking outside the popup
    popupOverlay.addEventListener('click', function (event) {
      if (event.target === popupOverlay) {
        hidePopup();
      }
    });

    // Redirect when clicking CTA
    popupConfirm.addEventListener('click', function () {
      window.location.href = "/products/complementary-movv-t-shirt";
    });

    function showPopup() {
      popupOverlay.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    }

    function hidePopup() {
      popupOverlay.style.display = 'none';
      document.body.style.overflow = '';
    }

    function attachFormListeners(form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        setTimeout(function () {
          showPopup();
        }, 1000);
      });
    }

    const existingForms = document.querySelectorAll('form[action="/cart/add"]');
    existingForms.forEach(attachFormListeners);

    const observer = new MutationObserver(function (mutationsList) {
      mutationsList.forEach(function (mutation) {
        if (mutation.type === "childList") {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeName === "FORM" && node.getAttribute("action") === "/cart/add") {
              attachFormListeners(node);
            } else if (node.querySelectorAll) {
              const newForms = node.querySelectorAll('form[action="/cart/add"]');
              newForms.forEach(attachFormListeners);
            }
          });
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
});